<template>
  <v-layout
    v-if="!$apollo.loading && whitelabelStats" 
    class="overview-card" 
    wrap
  >
    <v-flex
      md12
      xs12
    >
      <v-card>
        <v-layout wrap>
          <v-flex :class="!isSameMainCurrency ? 'col-xs-12 col-md-2' : 'col-xs-12 col-md-5'">
            <span>{{ $t('traderdashboard.revenue') }}</span>
            <p
              class="text-primary mt-2"
              style="font-size:26px;"
            >
              {{ 'USD' | renderSymbol }} {{ whitelabelStats.revenue.total }}
            </p>
          </v-flex>
          <v-flex
            md2
            xs12
          >
            <span>{{ $t('traderdashboard.revenueSubscription') }}</span>
            <p
              class="mt-2"
            >
              {{ 'USD' | renderSymbol }} {{ whitelabelStats.revenue_subscription.total }}
            </p>
          </v-flex>
          <v-flex
            md2
            xs12
          >
            <span>{{ $t('traderdashboard.users') }}</span>
            <p
              class="mt-2"
            >
              {{ whitelabelStats.users.total }}
            </p>
          </v-flex>
          <v-flex
            md3
            xs12
          >
            <span>{{ $t('traderdashboard.balanceAllUsers') }}</span>
            <p
              class="mt-2"
            >
              {{ getUsersBalanceUsdt() }}
            </p>
          </v-flex>
          <v-flex
            v-if="!isSameMainCurrency"
            md3
            xs12
          >
            <span>{{ $t('traderdashboard.balanceAllUsersMainCurrency', {currency: getMainCurrency}) }}</span>
            <p
              class="mt-2"
            >
              {{ getUsersBalanceMainCurrency() }}
            </p>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
const TRADER_OVERVIEW_QUERY = require('@/graphql/queries/TraderOverview.gql');
import { mapGetters } from "vuex";

export default {
  name: 'TraderOverview',
  props: {
    whitelabelStats: {
      type: Object,
      default: null
    },
  },
  data: () => ({
    tooltip: null,
    loading: false,
  }),
  computed: {
    ...mapGetters("whitelabel", ["getMainCurrency"]),
    isSameMainCurrency() {
      return this.getMainCurrency && this.getMainCurrency === "USDT";
    }
  },
  methods: {
    getUsersBalanceUsdt() {
      const usdtBalance = this.whitelabelStats.users_balance.find(item => item.currency === "USDT");
      if(usdtBalance) {
        if(usdtBalance.symbol) {
          return `${usdtBalance.symbol}${usdtBalance.amount.toFixed(2)}`;
        } 
        return `${usdtBalance.amount.toFixed(2)} ${usdtBalance.currency}`;
      }       
      return `$0.00`;
    },
    getUsersBalanceMainCurrency() {
      const usdtBalance = this.whitelabelStats.users_balance.find(item => item.currency === this.getMainCurrency);
      if(usdtBalance) {
        if (usdtBalance.symbol) {
          return `${usdtBalance.symbol}${usdtBalance.amount.toFixed(2)}`;
        }
        return `${usdtBalance.amount.toFixed(2)} ${usdtBalance.currency}`;
      }
      return `0.00`;
    }
  }
}
</script>



<style lang="scss" >
  .overview-card {
    .balance {
      font-weight: 700;
      font-size: 19px;
    }
    .v-btn__content {
      color: #fff;
      font-size: 15px;
    }
    span {
      font-size: 11px;
      font-weight: 600;
      color: #7f97ab;
      text-transform: uppercase;
    }
    p {
      padding-top: 5px;
      font-size: 18px;
      font-weight: 700;
    }
  }
</style>
